import React from 'react'
import {Button, Modal} from 'react-bootstrap'

type Props = {
  deleteModal: boolean
  handleDeleteModal: () => void
  title: string
}

const DeleteModals = ({deleteModal, handleDeleteModal, title}: Props) => {
  return (
    <Modal show={deleteModal} onHide={handleDeleteModal}>
      <Modal.Header closeButton>
        <Modal.Title>Are you shure you want to delete {title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Button variant='secondary' onClick={handleDeleteModal} className='mx-4'>
          Close
        </Button>
        <Button variant='danger'>Delete</Button>
      </Modal.Body>
    </Modal>
  )
}

export default DeleteModals
